module.exports = __webpack_public_path__ + "img/spb_logo.5489410.png";